import axios from "../../customAxios";
import {
  USER_LIST_REQUEST,
  USER_LIST_SUCCESS,
  USER_LIST_FAIL,
  USER_ADD_REQUEST,
  USER_ADD_SUCCESS,
  USER_ADD_FAIL,
  USER_UPDATE_REQUEST,
  USER_UPDATE_SUCCESS,
  USER_UPDATE_FAIL
} from "../constants/userListConstants";
import { toast } from 'react-toastify'

export const getUserData = (page = 1, limit = 10,search) => async (dispatch) => {
  try {
    dispatch({ type: USER_LIST_REQUEST });
    const res = await axios.get(`/api/v1/admin/getUser?page=${page}&limit=${limit}&search=${search}`);
    dispatch({ type: USER_LIST_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: USER_LIST_FAIL, payload: err.message });
  }
};

export const addUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: USER_ADD_REQUEST });
    const res = await axios.post("/api/v1/admin/addUserByAdmin", userData);
    dispatch({ type: USER_ADD_SUCCESS, payload: res.data });
  } catch (err) {
    dispatch({ type: USER_ADD_FAIL, payload: err.message });
  }
};

export const updateUser = (userData) => async (dispatch) => {
  try {
    dispatch({ type: USER_UPDATE_REQUEST });
    const res = await axios.put(`/api/v1/admin/editUser/${userData._id}`, userData);
    dispatch({ type: USER_UPDATE_SUCCESS, payload: res.data });
    toast.success(res.data.message);
  } catch (err) {
    dispatch({ type: USER_UPDATE_FAIL, payload: err.message });
  }
};
